import { Typography } from '@mui/material';
import {
  getPricingType,
  postShowTrialEndModal,
} from '@Store/feature/pricingSlice';
import React, { useEffect, useRef, useState } from 'react';
import { ComponentHelper } from '../../../helper/Infra';
import { ICTask, TaskResponse } from '../../../helper/Interfaces';
import { MergefloColors } from '../../../helper/MergefloColors';
import { getAssetsFunctionalAreas } from '../../../store/feature/assetsSlice';
import {
  getPlayBookDetail,
  postDealTaskList,
} from '../../../store/feature/playBookDetailSlice';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import classes from '../AddNewDependencyWidget/AddNewDependencyWidget.module.css';
import CustomTag from '../CustomTag/CustomTag';

type AddNewDependencyWidgetProps = {
  className?: string;
  taskId: string;
  sourceFunctionalAreaId: string;
  disabled?: boolean;
};

export default function AddNewDependencyWidget({
  className,
  sourceFunctionalAreaId,
  taskId,
  disabled,
}: AddNewDependencyWidgetProps) {
  const classesList = [
    classes.newDependency,
    classes.DependenciesCard,
    className,
  ];
  const [open, setOpen] = useState<boolean>(false);
  const [onProcess, setonProcess] = useState(false);
  const dispatch = useAppDispatch();
  const componentHelper = new ComponentHelper();
  const pricingReducer = useAppSelector(getPricingType);
  const isTrialEnd = componentHelper.isDealspaceTrialEnd(pricingReducer);
  const functionalAreas = useAppSelector(getAssetsFunctionalAreas);
  const { dealTaskList } = useAppSelector(getPlayBookDetail);
  const [discludedFunctionalAreas, setdiscludedFunctionalAreas] = useState<
    string[]
  >([]);

  useEffect(() => {
    const submittedFunctionalAreas = dealTaskList
      .filter(
        i =>
          i.type === 'dependency' && i.parentId === taskId && !i.sourceDeleted
      )
      .map(t => t.dependencyTarget!);
    const uniqueSubmittedFunctionalAres = Array.from(
      new Set(submittedFunctionalAreas)
    );
    setdiscludedFunctionalAreas(uniqueSubmittedFunctionalAres);
  }, [dealTaskList, taskId]);

  const mergefloColors = new MergefloColors();
  const container = useRef<HTMLDivElement>(null);

  const handleClickOutside = (event: any) => {
    if (container.current && !container.current.contains(event.target)) {
      setOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      // clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  });

  const dependencyNumber = functionalAreas
    ?.filter(f => f.isIMO || f.dealspaceId)
    ?.filter(
      i =>
        !discludedFunctionalAreas.includes(i.id) &&
        i.id !== sourceFunctionalAreaId
    ).length;

  return (
    <div ref={container} style={{ position: 'relative' }}>
      <button
        disabled={disabled ?? false}
        onClick={() => {
          if (isTrialEnd) {
            dispatch(postShowTrialEndModal(true));
            return;
          }
          setOpen(!open);
        }}
        className={classesList.join(' ')}
      >
        <span>+ Add new dependency </span>
      </button>
      <div>
        {open && (
          <div className={classes.newDependencyContent}>
            {dependencyNumber && dependencyNumber > 0 ? (
              functionalAreas
                ?.filter(f => f.isIMO || f.dealspaceId)
                ?.filter(
                  i =>
                    !discludedFunctionalAreas.includes(i.id) &&
                    i.id !== sourceFunctionalAreaId
                )
                ?.map(f => {
                  return (
                    <CustomTag
                      key={f.id}
                      padding="2px 8px 2px 8px"
                      borderRadius="15px"
                      textColor="#ffffff"
                      color={
                        f.color ?? mergefloColors.getPlaybookColor(f.shortName)
                      }
                      text={f.name}
                      clickHandler={async () => {
                        if (!onProcess) {
                          console.log('here');

                          setonProcess(true);
                          const created =
                            await componentHelper.createDependency({
                              name: ' ',
                              parentId: taskId,
                              functionalAreaId: f.id,
                            });

                          const newDependencyResponse =
                            created.data as TaskResponse;
                          const newDependencyCreated =
                            newDependencyResponse.taskDto as ICTask[];
                          newDependencyCreated[0].playbookFunction =
                            sourceFunctionalAreaId;
                          newDependencyCreated[0].dependencyTarget = f.id;
                          newDependencyCreated[0].dependencySource =
                            sourceFunctionalAreaId;

                          let patchAllTasks = [...dealTaskList];
                          let headerTask = patchAllTasks.find(
                            i => i.id === taskId
                          );
                          if (headerTask) {
                            patchAllTasks = patchAllTasks.filter(
                              i => i.id !== headerTask?.id!
                            );
                            const newHeaderTask = JSON.parse(
                              JSON.stringify(headerTask)
                            );
                            newHeaderTask.dependenciesCount =
                              (newHeaderTask.dependenciesCount ?? 0) + 1;
                            patchAllTasks.push(newHeaderTask);
                          }
                          patchAllTasks.push(...newDependencyCreated);
                          dispatch(postDealTaskList([...patchAllTasks]));
                          setonProcess(false);
                        } else {
                          console.log('else');
                        }
                        console.log('clicked handler', f.id);
                      }}
                    />
                  );
                })
            ) : (
              <Typography sx={{ textAlign: 'center', m: 'auto' }}>
                There are no more workstreams to create a dependency. Go to
                Invite to Deal to create another.
              </Typography>
            )}{' '}
          </div>
        )}
      </div>
    </div>
  );
}
